export default {
  returnFormatName: {
    ContratanteModalidadeTermo: 'Contratante + Modalidade + Termo',
    ContratanteCodigoUnimedCartao: 'Contratante + Cod. da Unimed + Cartao',
    ContratanteNomeTipoBeneficiario: 'Contratante + Nome + Tipo Beneficiário',
    ContratanteNomeDataNascimento: 'Contratante + Nome + Data Nascimento',
  },
  returnPropName: {
    ContratanteModalidadeTermo: 'ContratanteModalidadeTermo',
    ContratanteCodigoUnimedCartao: 'ContratanteCodigoUnimedCartao',
    ContratanteNomeTipoBeneficiario: 'ContratanteNomeTipoBeneficiario',
    ContratanteNomeDataNascimento: 'ContratanteNomeDataNascimento',
  },
  returnPropId: {
    ContratanteModalidadeTermo: 1,
    ContratanteCodigoUnimedCartao: 2,
    ContratanteNomeTipoBeneficiario: 3,
    ContratanteNomeDataNascimento: 4,
  },
};
